import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "VOIDEN",
    description: "VOIDEN is a small motion and design studio. Identities, title sequences, posters and websites, made by six people in one room.",
    url: getOrigin(),
    ogImage: 'https://voiden-template.cdn.modulify.website/images/work/vanta-right.jpg',
    email: 'hello@voiden.studio',
    city: "",
    coordinates: "42.6629° N, 21.1655° E",
    timeZone: 'Europe/Belgrade',
    socials: [
        { label: "Instagram", href: 'https://www.instagram.com/voiden.studio' },
        { label: "Vimeo", href: 'https://vimeo.com/voidenstudio' }
    ]
}

export const NAVIGATION = [
    { label: "Work", href: '/work' },
    { label: "Studio", href: '/studio' },
    { label: "Contact", href: '/contact' }
]

export const HOME_LINE = "A small studio."

// Shown one at a time while the camera drifts closer
export const HOME_BEATS = [
    "Nothing leaves the studio",
    "unless it would survive",
    "being looked at for a long time."
]

// One sentence, set in three lines on large screens
export const STUDIO_LINES = [
    "Six people. One room.",
    "A few things,",
    "for a long time."
]

export const STUDIO_PHOTO = {
    src: "https://voiden-template.cdn.modulify.website/images/studio/room.jpg",
    alt: "The studio: late sun from the tall window, a dried plant and its shadow on the wall."
}

export const STUDIO_NOTE = "Open Tuesday to Friday. Please knock."

export const CONTACT_PROMPT = "Write to us..."

export const CONTACT_EMAIL_PROMPT = "Your email..."

export const CONTACT_RECEIVED = "Received."

export const COLOPHON = "© 2026 VOIDEN. Made in the dark."
